import { Injectable } from '@angular/core';
import { Environment } from '@core/models/global.models';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private config!: Environment;

  setConfig(config: Environment) {
    this.config = config;
  }

  get env(): Environment {
    return this.config;
  }
}
